import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MessageSquareIcon, ShoppingCartIcon, HeartIcon, TruckIcon, ClockIcon, CheckCircleIcon, ChevronDownIcon, ChevronUpIcon, ShieldCheckIcon } from 'lucide-react';
// Mock product data (in a real app, this would come from an API)
const mockProduct = {
  id: 1,
  name: 'Standard Corrugated Boxes',
  category: 'Boxes',
  supplier: 'BoxMaster Inc.',
  supplierRating: 4.8,
  supplierReviews: 324,
  rating: 4.5,
  reviews: 128,
  price: '$0.75 - $2.50',
  moq: '500 units',
  leadTime: '7-10 days',
  images: ['https://images.unsplash.com/photo-1607344645866-009c320c5ab8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1530274759283-4cc0bad2e715?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'],
  description: 'High-quality corrugated boxes suitable for shipping and storage. Available in multiple sizes and strengths. Our boxes are made from 100% recyclable materials and can be customized with your branding.',
  features: ['100% recyclable materials', 'Multiple sizes available', 'Customizable with your branding', 'Strong and durable construction', 'Suitable for shipping and storage', 'Available in single, double, and triple wall options'],
  specifications: [{
    name: 'Material',
    value: 'Corrugated cardboard'
  }, {
    name: 'Available Sizes',
    value: 'Small (8x6x4"), Medium (12x10x8"), Large (18x14x12")'
  }, {
    name: 'Wall Options',
    value: 'Single wall, Double wall, Triple wall'
  }, {
    name: 'Customization',
    value: 'Custom printing available'
  }, {
    name: 'Minimum Order',
    value: '500 units'
  }, {
    name: 'Lead Time',
    value: '7-10 business days'
  }, {
    name: 'Certifications',
    value: 'FSC certified materials'
  }],
  pricingTiers: [{
    quantity: '500-999',
    price: '$2.50 per unit'
  }, {
    quantity: '1,000-4,999',
    price: '$1.50 per unit'
  }, {
    quantity: '5,000-9,999',
    price: '$1.00 per unit'
  }, {
    quantity: '10,000+',
    price: '$0.75 per unit'
  }],
  relatedProducts: [{
    id: 2,
    name: 'Eco-Friendly Mailers',
    image: 'https://images.unsplash.com/photo-1676299081847-824916254791?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
    price: '$0.35 - $0.85'
  }, {
    id: 3,
    name: 'Custom Printed Tape',
    image: 'https://images.unsplash.com/photo-1635405074683-96d6921a2a68?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
    price: '$3.25 - $5.50'
  }, {
    id: 4,
    name: 'Bubble Wrap Rolls',
    image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
    price: '$15.00 - $45.00'
  }]
};
export function ProductDetail() {
  const {
    id
  } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(500);
  const [activeTab, setActiveTab] = useState('description');
  const [showPricingTable, setShowPricingTable] = useState(false);
  const [showSpecifications, setShowSpecifications] = useState(false);
  // In a real app, you would fetch the product based on the ID
  // For this demo, we'll just use the mock product
  const product = mockProduct;
  return <div className="space-y-6" data-id="element-563">
      {/* Product Overview */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-564">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6" data-id="element-565">
          {/* Product Images */}
          <div className="space-y-4" data-id="element-566">
            <div className="aspect-square overflow-hidden rounded-lg bg-gray-100" data-id="element-567">
              <img src={product.images[selectedImage]} alt={product.name} className="h-full w-full object-cover object-center" data-id="element-568" />
            </div>
            <div className="grid grid-cols-4 gap-2" data-id="element-569">
              {product.images.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`aspect-square overflow-hidden rounded-md ${selectedImage === index ? 'ring-2 ring-blue-500' : 'ring-1 ring-gray-200'}`} data-id="element-570">
                  <img src={image} alt={`${product.name} ${index + 1}`} className="h-full w-full object-cover object-center" data-id="element-571" />
                </button>)}
            </div>
          </div>
          {/* Product Details */}
          <div className="space-y-6" data-id="element-572">
            <div data-id="element-573">
              <div className="text-sm font-medium text-blue-600 uppercase tracking-wide" data-id="element-574">
                {product.category}
              </div>
              <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl" data-id="element-575">
                {product.name}
              </h1>
              <div className="mt-2 flex items-center" data-id="element-576">
                <div className="flex items-center" data-id="element-577">
                  {[...Array(5)].map((_, i) => <svg key={i} className={`h-5 w-5 ${i < Math.floor(product.rating) ? 'text-yellow-400' : i < product.rating ? 'text-yellow-300' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-578">
                      <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-579" />
                    </svg>)}
                </div>
                <p className="ml-2 text-sm text-gray-500" data-id="element-580">
                  {product.reviews} reviews
                </p>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-4" data-id="element-581">
              <div className="flex items-center justify-between" data-id="element-582">
                <div data-id="element-583">
                  <h2 className="sr-only" data-id="element-584">Product information</h2>
                  <p className="text-lg text-gray-900 sm:text-xl" data-id="element-585">
                    {product.price}
                  </p>
                  <button onClick={() => setShowPricingTable(!showPricingTable)} className="mt-1 flex items-center text-sm text-blue-600 hover:text-blue-500" data-id="element-586">
                    See volume pricing
                    {showPricingTable ? <ChevronUpIcon className="ml-1 h-4 w-4" data-id="element-587" /> : <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-588" />}
                  </button>
                </div>
                <div className="text-right" data-id="element-589">
                  <p className="text-sm text-gray-500" data-id="element-590">MOQ: {product.moq}</p>
                  <p className="text-sm text-gray-500" data-id="element-591">
                    Lead Time: {product.leadTime}
                  </p>
                </div>
              </div>
              {showPricingTable && <div className="mt-4 overflow-hidden rounded-lg border border-gray-200" data-id="element-592">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-593">
                    <thead className="bg-gray-50" data-id="element-594">
                      <tr data-id="element-595">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-596">
                          Quantity
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-597">
                          Price
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-598">
                      {product.pricingTiers.map(tier => <tr key={tier.quantity} data-id="element-599">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-600">
                            {tier.quantity}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-601">
                            {tier.price}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>}
            </div>
            <div className="border-t border-gray-200 pt-4" data-id="element-602">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-603">Supplier</h3>
              <div className="mt-2 flex items-center justify-between" data-id="element-604">
                <div className="flex items-center" data-id="element-605">
                  <div className="h-10 w-10 flex-shrink-0 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-606">
                    <span className="font-medium text-blue-800" data-id="element-607">
                      {product.supplier.charAt(0)}
                    </span>
                  </div>
                  <div className="ml-3" data-id="element-608">
                    <p className="text-sm font-medium text-gray-900" data-id="element-609">
                      {product.supplier}
                    </p>
                    <div className="flex items-center" data-id="element-610">
                      <div className="flex items-center" data-id="element-611">
                        {[...Array(5)].map((_, i) => <svg key={i} className={`h-4 w-4 ${i < Math.floor(product.supplierRating) ? 'text-yellow-400' : i < product.supplierRating ? 'text-yellow-300' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-612">
                            <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-613" />
                          </svg>)}
                      </div>
                      <p className="ml-1 text-xs text-gray-500" data-id="element-614">
                        {product.supplierRating} ({product.supplierReviews}{' '}
                        reviews)
                      </p>
                    </div>
                  </div>
                </div>
                <Link to={`/suppliers/${product.supplier.replace(/\s+/g, '-').toLowerCase()}`} className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-615">
                  View Profile
                </Link>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-4" data-id="element-616">
              <div className="flex items-center space-x-4" data-id="element-617">
                <div className="flex-1" data-id="element-618">
                  <label htmlFor="quantity" className="block text-sm font-medium text-gray-700" data-id="element-619">
                    Quantity
                  </label>
                  <div className="mt-1 flex rounded-md shadow-sm" data-id="element-620">
                    <input type="number" name="quantity" id="quantity" min="500" step="100" value={quantity} onChange={e => setQuantity(parseInt(e.target.value))} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-621" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-622">
                  <label htmlFor="size" className="block text-sm font-medium text-gray-700" data-id="element-623">
                    Size
                  </label>
                  <select id="size" name="size" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-624">
                    <option data-id="element-625">Small (8x6x4")</option>
                    <option data-id="element-626">Medium (12x10x8")</option>
                    <option data-id="element-627">Large (18x14x12")</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-4 space-y-3" data-id="element-628">
              <button className="w-full flex items-center justify-center bg-blue-600 py-3 px-8 rounded-md text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-629">
                <MessageSquareIcon className="mr-2 h-5 w-5" data-id="element-630" />
                Contact Supplier
              </button>
              <button className="w-full flex items-center justify-center bg-gray-100 py-3 px-8 rounded-md text-base font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" data-id="element-631">
                <ShoppingCartIcon className="mr-2 h-5 w-5" data-id="element-632" />
                Request Quote
              </button>
              <button className="w-full flex items-center justify-center border border-gray-300 py-3 px-8 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" data-id="element-633">
                <HeartIcon className="mr-2 h-5 w-5" data-id="element-634" />
                Save for Later
              </button>
            </div>
            <div className="border-t border-gray-200 pt-4" data-id="element-635">
              <div className="flex items-center space-x-2" data-id="element-636">
                <ShieldCheckIcon className="h-5 w-5 text-green-500" data-id="element-637" />
                <span className="text-sm text-gray-500" data-id="element-638">Verified Supplier</span>
              </div>
              <div className="mt-2 flex items-center space-x-2" data-id="element-639">
                <TruckIcon className="h-5 w-5 text-blue-500" data-id="element-640" />
                <span className="text-sm text-gray-500" data-id="element-641">
                  Free shipping on orders over $1000
                </span>
              </div>
              <div className="mt-2 flex items-center space-x-2" data-id="element-642">
                <ClockIcon className="h-5 w-5 text-blue-500" data-id="element-643" />
                <span className="text-sm text-gray-500" data-id="element-644">
                  30-day return policy
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Product Details Tabs */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-645">
        <div className="border-b border-gray-200" data-id="element-646">
          <nav className="flex -mb-px" aria-label="Tabs" data-id="element-647">
            <button onClick={() => setActiveTab('description')} className={`${activeTab === 'description' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-648">
              Description
            </button>
            <button onClick={() => setActiveTab('specifications')} className={`${activeTab === 'specifications' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-649">
              Specifications
            </button>
            <button onClick={() => setActiveTab('reviews')} className={`${activeTab === 'reviews' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-650">
              Reviews
            </button>
          </nav>
        </div>
        <div className="p-6" data-id="element-651">
          {activeTab === 'description' && <div className="space-y-6" data-id="element-652">
              <p className="text-base text-gray-700" data-id="element-653">{product.description}</p>
              <div data-id="element-654">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-655">Features</h3>
                <ul className="mt-4 space-y-2" data-id="element-656">
                  {product.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-657">
                      <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-658" />
                      <span className="text-gray-700" data-id="element-659">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </div>}
          {activeTab === 'specifications' && <div className="overflow-hidden" data-id="element-660">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-661">
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-662">
                  {product.specifications.map(spec => <tr key={spec.name} data-id="element-663">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-664">
                        {spec.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-665">
                        {spec.value}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
          {activeTab === 'reviews' && <div className="space-y-8" data-id="element-666">
              <div className="flex items-center space-x-4" data-id="element-667">
                <div data-id="element-668">
                  <div className="text-3xl font-bold text-gray-900" data-id="element-669">
                    {product.rating}
                  </div>
                  <div className="flex items-center mt-1" data-id="element-670">
                    {[...Array(5)].map((_, i) => <svg key={i} className={`h-5 w-5 ${i < Math.floor(product.rating) ? 'text-yellow-400' : i < product.rating ? 'text-yellow-300' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-671">
                        <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-672" />
                      </svg>)}
                  </div>
                  <div className="text-sm text-gray-500 mt-1" data-id="element-673">
                    {product.reviews} reviews
                  </div>
                </div>
                <div className="flex-1" data-id="element-674">
                  <div className="space-y-2" data-id="element-675">
                    {[5, 4, 3, 2, 1].map(rating => <div key={rating} className="flex items-center" data-id="element-676">
                        <div className="text-sm text-gray-500 w-8" data-id="element-677">
                          {rating}★
                        </div>
                        <div className="flex-1 ml-2" data-id="element-678">
                          <div className="h-2 bg-gray-200 rounded-full" data-id="element-679">
                            <div className="h-2 bg-yellow-400 rounded-full" style={{
                        width: `${rating === 5 ? 70 : rating === 4 ? 20 : rating === 3 ? 5 : rating === 2 ? 3 : 2}%`
                      }} data-id="element-680"></div>
                          </div>
                        </div>
                        <div className="text-sm text-gray-500 ml-2 w-8" data-id="element-681">
                          {rating === 5 ? 70 : rating === 4 ? 20 : rating === 3 ? 5 : rating === 2 ? 3 : 2}
                          %
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 pt-6" data-id="element-682">
                <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-683">
                  Write a Review
                </button>
              </div>
              {/* Sample reviews */}
              <div className="space-y-6" data-id="element-684">
                <div className="border-t border-gray-200 pt-6" data-id="element-685">
                  <div className="flex items-start" data-id="element-686">
                    <div className="flex-shrink-0" data-id="element-687">
                      <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-688">
                        <span className="font-medium text-gray-700" data-id="element-689">J</span>
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-690">
                      <h4 className="text-sm font-bold text-gray-900" data-id="element-691">
                        John D.
                      </h4>
                      <div className="flex items-center mt-1" data-id="element-692">
                        <div className="flex" data-id="element-693">
                          {[...Array(5)].map((_, i) => <svg key={i} className={`h-4 w-4 ${i < 5 ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-694">
                              <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-695" />
                            </svg>)}
                        </div>
                        <span className="ml-2 text-sm text-gray-500" data-id="element-696">
                          2 months ago
                        </span>
                      </div>
                      <p className="mt-2 text-sm text-gray-700" data-id="element-697">
                        These boxes are perfect for our shipping needs. The
                        quality is consistent and they hold up well during
                        transit. Will definitely order again.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="border-t border-gray-200 pt-6" data-id="element-698">
                  <div className="flex items-start" data-id="element-699">
                    <div className="flex-shrink-0" data-id="element-700">
                      <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-701">
                        <span className="font-medium text-gray-700" data-id="element-702">S</span>
                      </div>
                    </div>
                    <div className="ml-4" data-id="element-703">
                      <h4 className="text-sm font-bold text-gray-900" data-id="element-704">
                        Sarah M.
                      </h4>
                      <div className="flex items-center mt-1" data-id="element-705">
                        <div className="flex" data-id="element-706">
                          {[...Array(5)].map((_, i) => <svg key={i} className={`h-4 w-4 ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-707">
                              <path fillRule="evenodd" d="M10 15.585l-5.196 2.73 1-5.82-4.196-4.073 5.8-.844L10 2.979l2.592 5.26 5.8.844-4.196 4.073 1 5.82z" clipRule="evenodd" data-id="element-708" />
                            </svg>)}
                        </div>
                        <span className="ml-2 text-sm text-gray-500" data-id="element-709">
                          3 months ago
                        </span>
                      </div>
                      <p className="mt-2 text-sm text-gray-700" data-id="element-710">
                        Good quality boxes but shipping took longer than
                        expected. The boxes themselves are sturdy and work well
                        for our products.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center pt-6" data-id="element-711">
                <button className="text-blue-600 hover:text-blue-500 font-medium" data-id="element-712">
                  Load more reviews
                </button>
              </div>
            </div>}
        </div>
      </div>
      {/* Mobile Specifications (Accordion) */}
      <div className="md:hidden bg-white rounded-lg shadow overflow-hidden" data-id="element-713">
        <button onClick={() => setShowSpecifications(!showSpecifications)} className="w-full px-6 py-4 flex items-center justify-between focus:outline-none" data-id="element-714">
          <span className="text-lg font-medium text-gray-900" data-id="element-715">
            Specifications
          </span>
          {showSpecifications ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-716" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-717" />}
        </button>
        {showSpecifications && <div className="px-6 pb-6" data-id="element-718">
            <div className="space-y-4" data-id="element-719">
              {product.specifications.map(spec => <div key={spec.name} data-id="element-720">
                  <dt className="text-sm font-medium text-gray-900" data-id="element-721">
                    {spec.name}
                  </dt>
                  <dd className="mt-1 text-sm text-gray-500" data-id="element-722">{spec.value}</dd>
                </div>)}
            </div>
          </div>}
      </div>
      {/* Related Products */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-723">
        <div className="px-6 py-5 border-b border-gray-200" data-id="element-724">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-725">
            Related Products
          </h2>
        </div>
        <div className="p-6" data-id="element-726">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-727">
            {product.relatedProducts.map(relatedProduct => <Link key={relatedProduct.id} to={`/products/${relatedProduct.id}`} className="group" data-id="element-728">
                <div className="aspect-square w-full overflow-hidden rounded-lg bg-gray-100" data-id="element-729">
                  <img src={relatedProduct.image} alt={relatedProduct.name} className="h-full w-full object-cover object-center group-hover:opacity-75" data-id="element-730" />
                </div>
                <h3 className="mt-4 text-sm text-gray-700" data-id="element-731">
                  {relatedProduct.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-732">
                  {relatedProduct.price}
                </p>
              </Link>)}
          </div>
        </div>
      </div>
    </div>;
}